<template>
  <div class="data-center">
    <a @click="$router.go(-1)" class="button return-button">
      <img src="../assets/pictos/back-arrow.svg">
      Retour
    </a>
    <div class="head">
      <h2>Vos données et vos droits</h2>
    </div>
    <div class="content">
      <div class="section">
        <p>
          Nous attachons une grande importance au respect de votre vie privée et à la protection de vos données.
          <br>
          Nous nous engageons ainsi à assurer le meilleur niveau de protection à vos données personnelles et à les traiter de manière loyale et transparente, conformément aux réglementations européennes et françaises applicables en matière de protection des données personnelles.
          <br>
          Vous trouverez ainsi sur cette page l’ensemble des notices d’information relatives aux traitements de données que nous réalisons ainsi que nos politiques relatives à la gestion des cookies et Privacy.
        </p>
        <br>
        <h2>NOTICES D’INFORMATION</h2>
        <p>
          Retrouvez ici la liste et le détail de tous nos traitements
        </p>
        <br>
        <div class="tab">
          <input type="checkbox" id="tab-demande-info" name="tabs">
          <label for="tab-demande-info">Notice d'information : Signalement d'erreur</label>
          <div class="tab-content">
            <p>
              La présente notice a pour objet de vous apporter l’ensemble des éléments d’information prévus par la règlementation applicable et, en particulier, par le Règlement européen Général sur la protection des données (« RGPD »).
            </p>
            <h5>Identité et coordonnées du responsable du traitement :</h5>
            <p>
              PIA Production SAS <br>
              Le Forum – Bâtiment B <br>
              27 rue Maurice Flandin <br>
              69003 LYON <br>
              Représentée par :  Monsieur Florent Buffin
            </p>
            <h5>Objet du traitement :</h5>
            <ul>
              <li>
                Finalité(s) :
                <p>
                  Ce traitement a été mis en place afin de :
                </p>
                <ul>
                  <li>Vous permettre de signaler une erreur ou un problème dans le contenu du site.</li>
                </ul>
              </li>
              <li>
                Base(s) juridique(s) du traitement :
              </li>
            </ul>
            <p>
              Ce traitement s’inscrit dans un intérêt légitime à offrir à nos clients la possibilité de signaler une erreur sur le site.
            </p>
            <h5>
              Destinataire(s) :
            </h5>
            <p>
              Les informations liées à votre demande et les données personnelles permettant de vous contacter sont communiquées à nos services internes ou à des sociétés partenaires afin de vous apporter une réponse correspondant à vos besoins.
            </p>

            <h5>Catégorie(s) de données concernées :</h5>
            <ul>
              <li>Toutes les données saisies dans le champs description de l'erreur</li>
            </ul>

            <h5>Durée(s) de conservation des données :</h5>
            <p>
              Nous ne conserverons vos données que pendant la durée strictement nécessaire aux finalités énoncées précédemment ou pour satisfaire à nos obligations légales ou en vue d'exercer, de défendre ou de faire valoir nos droits.
            </p>
            <h5>Droits des personnes :</h5>
            <p>Vous pouvez exercer l’ensemble des droits suivants sur vos données personnelles :</p>
            <ul>
              <li>Droit d’accès ;</li>
              <li>Droit de rectification ;</li>
              <li>Droit à l’effacement ;</li>
              <li>Droit à la limitation du traitement ;</li>
              <li>Droit d’opposition ;</li>
              <li>Droit à la portabilité.</li>
            </ul>
            <p>
              Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés ou que le présent traitement de données n’est pas conforme aux règles de protection des données, vous disposez du droit d’introduire une réclamation auprès de la
              <a href="https://www.cnil.fr/fr/plaintes">Commission Nationale de l’Informatique et des Libertés</a> (CNIL).
              <br>
              Pour exercer ces droits ou pour toute question sur le traitement de vos données par notre société, consultez la rubrique « Comment exercer vos droits ».
            </p>
            <h5>Information(s) complémentaire(s)</h5>
            <p>
              Nous vous rappelons que conformément aux dispositions de l’article 40-1 de la loi 78-17 du 6 janvier 1978, vous disposez du droit de formuler des directives générales (auprès d’un tiers de confiance numérique certifié par la CNIL) ou particulières (auprès du responsable de traitement) relatives à la conservation, à l’effacement et à la communication de vos données à caractère personnel après votre décès.
            </p>
          </div>
        </div>
      </div>
      <div class="section">
        <h2>COOKIES</h2>
        <h3>Utilisation de temoins de connexion (« cookies »)</h3>
        <p>
          Lors de la consultation du site, des témoins de connexions, dits « cookies », sont déposés sur votre ordinateur, votre mobile ou votre tablette.
          Ces cookies sont utilisés pour :
        </p>
        <ul>
          <li>déterminer si la personne a coché la case « Se souvenir de moi ». Ce cookie est un cookie technique permettant de conserver le token d’authentification de l’utilisateur. Il est stocké côté client.</li>
          <li>stocker le token d’authentification de l’utilisateur. C’est un cookie technique obligatoire pour effectuer les restitutions dans l’application front. Sa durée de conservation dépend du cookie ci-dessus. Il est stocké côté client.</li>
        </ul>
        <h3>À savoir</h3>
        <div>
          <ul>
            <li>Les données collectées ne sont pas recoupées avec d’autres traitements ;</li>
            <li>Le cookie déposé sert uniquement à la production de statistiques anonymes ;</li>
            <li>Le cookie ne permet pas de suivre la navigation de l’internaute sur d’autres sites.</li>
          </ul>
          <br>
          Vous pouvez paramétrer votre navigateur afin qu’il vous signale la présence de cookies et vous propose de les accepter ou non. Vous pouvez accepter ou refuser les cookies au cas par cas ou bien les refuser une fois pour toutes. Il est rappelé que ce paramétrage est susceptible de modifier vos conditions d’accès aux services du site nécessitant l’utilisation de cookies.
          <br>
          Le paramétrage des cookies est différent pour chaque navigateur et en général décrit dans les menus d’aide.
          <br>
          Pour Chrome :
          <a href="http://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647">http://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647</a>
          <br>
          Pour Firefox :
          <a href="http://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies">http://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies</a>
          <br>
          Pour Internet Explorer :
          <a href="http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies">http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies</a>
          <br>
          Pour Opera :
          <a href="http://help.opera.com/Windows/10.20/fr/cookies.html">http://help.opera.com/Windows/10.20/fr/cookies.html</a>
          <br>
          Pour Safari :
          <a href="https://support.apple.com/kb/PH19214?locale=fr_FR&viewlocale=fr_FR">https://support.apple.com/kb/PH19214?locale=fr_FR&viewlocale=fr_FR</a>
          <br>
          <br>
          Plus d’informations sur les cookies :
          <a href="https://www.cnil.fr/vos-droits/vos-traces/les-cookies/">https://www.cnil.fr/vos-droits/vos-traces/les-cookies/</a>
        </div>
      </div>
      <div class="section">
        <h2>CHARTE DES DONNÉES PERSONNELLES</h2>
        <h3>De quoi s’agit-il ?</h3>
        <p>
          Chez PIA Production, le respect de la vie privée représente un enjeu majeur et nous nous engageons à la protéger.
          Conformément au Règlement Général sur la Protection des Données (« RGPD » ou « GDPR » en anglais), cette politique a pour but de préciser quand, pourquoi et comment nous :
        </p>
        <ul>
          <li>recueillons des données personnelles relatives à une personne physique ;</li>
          <li>utilisons ces informations ;</li>
          <li>communiquons de telles données à un tiers, lorsque cela s’avère nécessaire et dans certaines conditions ;</li>
          <li>assurons la confidentialité de ces données personnelles.</li>
        </ul>
        <p>
          Dans le cadre de la présente politique et sauf indication contraire, l’emploi des mots « nous », « notre » ou « notre Société » fait référence à PIA Production.
          <br>
          Le RGPD a catégorisé les entreprises selon deux types majeurs, les responsables de traitement et les sous-traitants, définis selon leur position dans la chaîne de collecte et de circulation des données personnelles.
          <br>
          Le responsable de traitement détermine le but, les conditions et les moyens liés au traitement des données personnelles. Le sous-traitant traite les données pour le compte du responsable de traitement. Pour autant, chaque entreprise soumise au RGPD est un peu des deux.
        </p>
        <h3>Comment cette politique peut évoluer</h3>
        <p>
          Cette politique est susceptible d’évoluer périodiquement, vous pourrez consulter la présente page afin de prendre connaissance de la version la plus récente.
          La dernière mise à jour de cette politique a été réalisée le 13 mars 2019.
        </p>
        <h3>La collecte de vos données personnelles</h3>
        <h4>Lesquelles ?</h4>
        <p>
          Nous pouvons recueillir et traiter les données personnelles suivantes :
        </p>
        <ul>
          <li>
            <p>Les données personnelles que vous nous fournissez : il s’agit de renseignements que vous nous fournissez de votre plein gré en saisissant des informations via :</p>
            <ul>
              <li>un de nos sites internet ;</li>
              <li>nos applications bureaux et mobiles ;</li>
              <li>une correspondance avec nous par voie téléphonique, e-mail ou tout autre moyen.
                <p>Exemple : sont concernés, entre autres, des renseignements communiqués à l’occasion : </p>
                <ul>
                  <li>de votre création de compte utilisateur sur nos sites internet ;</li>
                  <li>de votre abonnement aux services que nous mettons à votre disposition via nos sites internet ;</li>
                  <li>de la demande de services complémentaires ;</li>
                  <li>ou dans le cadre de la gestion de votre compte en ligne (y compris l’accès à la documentation et la correspondance avec nous par téléphone, e-mail ou autrement).</li>
                </ul>
              </li>
              Nous sommes également susceptibles de vous demander des renseignements si vous nous signalez un problème avec nos sites internet, ou encore si vous participez à nos études et sondages réalisés à des fins de recherches.
              Les informations que vous nous communiquez peuvent porter sur votre identification, notamment vos nom, adresse postale, adresse e-mail et numéro de téléphone, des renseignements au sujet de la demande que vous nous auriez adressée, et peuvent également inclure des enregistrements relatifs à nos correspondances ainsi que vos réponses à différents sondages.
            </ul>
          </li>
          <li>
            Les données personnelles vous concernant que nous pouvons recueillir automatiquement :
            <ul>
              <li>les informations relatives aux transactions que vous effectuez sur les sites internet, ainsi que vos visites sur nos sites internet, avec, mais sans s’y limiter : les données relatives au trafic, à la localisation, aux Weblogs et toute autre donnée de communication, ainsi que les ressources auxquelles vous accédez ;</li>
              <li>les informations techniques, automatiquement recueillies, y compris les données anonymes recueillies par le serveur d’hébergement à des fins statistiques, l’adresse IP (Internet Protocol) utilisée pour connecter votre appareil à Internet, le type et la version du navigateur, le réglage du fuseau horaire, les types et les versions de plug-in du navigateur, le système d’exploitation et la plateforme. Consultez la partie consacrée aux cookies pour plus d’informations.</li>
            </ul>
          </li>
          <li>
            Les données personnelles que nous pouvons recevoir d’autres sources :
            <ul>
              <li>
                nous obtenons certaines données personnelles vous concernant de sources extérieures à notre Société, y compris d’autres sociétés tierces.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          Les autres dispositions de la présente politique s’appliquent également à l’ensemble des données personnelles que nous obtenons de ces sources.
        </p>
        <h4>Pourquoi ?</h4>
        <p>Nous traitons vos données personnelles en toute légalité dans le but :</p>
        <ul>
          <li>d’assurer la communication et/ou l’échange d’information avec les utilisateurs de nos sites internet ;</li>
          <li>de gérer les relations avec nos clients et prospects, notamment dans le cadre du traitement de vos commandes, des réponses à vos demandes ou de l’envoi régulier des actualités et informations relatives à nos produits, nos marques ou nos initiatives susceptibles de susciter votre intérêt ;</li>
          <li>ou dans tout autre but précisé au moment du recueil de vos données.</li>
        </ul>
        <p>Nous utilisons et traitons vos données personnelles principalement dans les conditions suivantes :</p>
        <ul>
          <li>lorsque vous avez exprimé votre <b>CONSENTEMENT</b> libre et explicite, pour des finalités déterminées, explicites et légitimes. Vous pouvez retirer votre consentement à tout moment en nous contactant.</li>
          <li>
            lorsque le traitement est nécessaire à la poursuite de nos <b>INTÉRÊTS LÉGITIMES</b> en tant qu’entreprise, à condition que ne prévalent pas vos intérêts ou vos libertés et droits fondamentaux compte tenu des attentes raisonnables que vous pouvez escompter au regard de la relation que vous entretenez avec nous.
            <br>
            Par exemple, pour les finalités suivantes :
            <ul>
              <li>la réalisation d’actions de marketing direct (différentes de celles basées sur votre consentement) telles que des analyses nous permettant d’affiner notre stratégie commerciale, ainsi que d’améliorer et de personnaliser votre expérience utilisateur ;</li>
              <li>la détection, la prévention et la réduction des fraudes ou d’autres activités illégales ;</li>
              <li>la sécurisation du réseau et de l’information nous permettant de prendre les mesures nécessaires pour protéger vos données des risques de perte ou d’altération, de vol ou d’accès non autorisé.</li>
            </ul>
          </li>
          <li>
            lorsque nous devons <b>RESPECTER UNE OBLIGATION LÉGALE</b>, et notamment :
            <ul>
              <li>pour assister une autorité publique ou un organisme dans le cadre d’une enquête ;</li>
              <li>pour vous identifier dans le cas où vous nous contactez, conformément à certains impératifs d’ordre juridique ;</li>
              <li>pour vérifier l’exactitude des données que nous détenons à votre sujet.</li>
            </ul>
          </li>
          <li>
            lorsque le traitement s’impose dans le cadre de <b>L’EXÉCUTION D’UN CONTRAT</b> qui existe entre nous ou lorsque que vous nous demandez de prendre des mesures particulières avant la conclusion de celui-ci, ce qui inclut notamment le traitement des informations nécessaires pour vous permettre d’utiliser nos sites internet et de bénéficier des services que nous proposons à travers ces derniers.
          </li>
        </ul>

        <h3>L’acces à vos données personnelles</h3>
        <h4>Nos fournisseurs et prestataires</h4>
        <p>
          Nous pouvons communiquer des informations vous concernant à des prestataires externes, agents, sous-traitants et autres organismes pour leur permettre de nous fournir des services ou de vous les fournir directement de notre part.
          Parmi ces parties tierces on peut citer des prestataires de cloud (notamment pour l’hébergement et la gestion de la messagerie), des services administratifs, des services de traitement des paiements par carte de crédit et de débit, des enquêtes de satisfaction clients ou d’autres parties tierces qui nous fournissent des services et nous assistent dans la réalisation de nos activités et l’exploitation de nos services.
          Lorsque nous avons recours à des prestataires externes, nous ne divulguons que les données personnelles nécessaires à leur prestation et nous mettons en place un contrat qui prévoit qu’ils assurent la sécurité et la confidentialité des renseignements vous concernant, et qui leur interdit de les utiliser à d’autres fins qui ne seraient pas conformes à nos directives spécifiques.
        </p>
        <h4>Autres moyens pour nous de partager des informations vous concernant</h4>
        <p>Nous pouvons transmettre vos données personnelles :</p>
        <ul>
          <li>Dans le cadre d’une cession d’une partie ou de l’intégralité de notre entreprise et de nos actifs à une partie tierce ou dans le cadre d’une restructuration ou d’une réorganisation de l’entreprise ;</li>
          <li>Si nous sommes dans l’obligation de divulguer ou de partager vos renseignements personnels afin de nous conformer à toute obligation légale, assignation, réquisition judiciaire ou réglementation gouvernementale, de déceler ou signaler un crime, d’exécuter ou appliquer les modalités de nos contrats ou de préserver les droits, la propriété ou la sécurité de nos visiteurs et clients ;</li>
          <li>Afin de faire respecter les conditions d’utilisation applicables, pour préserver les droits, dont le droit à la vie privée, la propriété ou la sécurité de nos sociétés ;</li>
          <li>Si vous avez consenti à cette communication.</li>
        </ul>
        <p>
          Cependant, dans les différents cas énoncés, nous prendrons toujours les mesures appropriées permettant de garantir la protection de vos droits à la vie privée.
        </p>

        <h3>Le stockage de vos données personnelles</h3>
        <h4>Où ?</h4>
        <p>
          Les renseignements vous concernant sont conservés soit dans nos bases de données, soit dans les bases de données de nos prestataires.
          Principalement dans le but d’optimiser la qualité des services, les informations que vous mettez à notre disposition peuvent, le cas échéant, être transmises à des pays en dehors de l’Espace Économique Européen (EEE).
          Dans ce cas, nous veillerons à ce que les mesures appropriées de sécurité et de confidentialité soient prises afin de garantir le maintien de la protection de vos droits à la vie privée comme précisé dans cette politique. Parmi ces mesures, il est prévu d’imposer des obligations contractuelles au destinataire de vos données personnelles ou de s’assurer que les destinataires ont souscrit à des « cadres internationaux » visant à assurer une protection suffisante de vos données.
        </p>
        <h4>Comment ?</h4>
        <p>
          Nous visons à conserver vos données en toute sécurité à tout moment de leur traitement. Dès la réception de vos données personnelles, nous mettons en place des mesures techniques et organisationnelles appropriées ainsi que différents contrôles afin de prévenir, dans la mesure du possible, toute destruction, perte, altération, divulgation ou accès non autorisé, de manière accidentelle ou illicite.
        </p>
        <h4>Combien de temps ?</h4>
        <p>Nous ne conservons vos données personnelles que le temps où elles nous sont nécessaires pour atteindre l’objectif de leur traitement, et pour répondre à nos différentes obligations légales et réglementaires. Sauf cas particulier, cette durée est indiquée au moment de la collecte de vos données personnelles. Nous ne conservons pas de données personnelles sous un format rendant possible l’identification de leur détenteur plus longtemps que ne l’exigent les finalités de leur collecte.</p>
        <h3>L’exercice de vos droits</h3>
        <p>Sous réserve des législations applicables et de certaines exemptions, restrictions ou circonstances, vous pourrez être en droit :</p>
        <ul>
          <li>D’accéder à vos données personnelles ;</li>
          <li>De corriger, modifier et mettre à jour vos données personnelles ;</li>
          <li>De supprimer vos données personnelles ou de limiter leur traitement ;</li>
          <li>De retirer votre consentement ;</li>
          <li>De vous opposer à ce que nous utilisions vos données personnelles afin :
            <ul>
              <li>De prendre des décisions automatisées à votre égard ;</li>
              <li>De nous demander de vous transmettre vos données personnelles dans un fichier structuré ou à un prestataire que vous nous indiqueriez si cela est techniquement possible (portabilité des données) ;</li>
              <li>De déposer une plainte auprès de l’autorité de contrôle compétente et de disposer d’un recours juridictionnel.</li>
            </ul>
          </li>
        </ul>
        <p>
          Ces droits peuvent être exercés en transmettant la demande écrite aux interlocuteurs dont les coordonnées sont indiquées dans la section "Comment exercer vos droits". Vous recevrez une réponse dans un délai raisonnable, conformément aux lois applicables.
        </p>
      </div>
      <div class="section">
        <h2>COMMENT EXERCER VOS DROITS ?</h2>
        <p>
          Si vous avez des questions sur la manière dont nous traitons et utilisons vos données, ou si vous souhaitez exercer l’un quelconque de vos droits Informatique et Libertés, vous pouvez nous contacter à l’adresse suivante
          <a href="mailto:privacycontact@pia-production.fr">privacycontact@pia-production.fr</a>
          ou nous écrire à l’adresse postale suivante :
        </p>
        <div class="adresse">
          Données personnelles PIA Production SAS <br>
          Le Forum – Bâtiment B <br>
          27 rue Maurice Flandin <br>
          69003 LYON
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataCenter'
}
</script>

<style lang="scss">
.data-center {
  position: relative;
  margin-top: $v-spacer-xl;
  .head {
    background-color: $primary-color;
    border-radius: $radius $radius 0 0;
    color: #fff;
    display: flex;
    align-items: center;
    padding: $v-spacer $h-spacer-lg;
    text-align: left;
    h2 {
      margin: 0;
    }
  }
  .content {
    background-color: #fff;
    border-radius: 0 0 $radius $radius;
    padding: 25px;
    text-align: left;
    font-family: $secondary-font;
    font-size: $text-size;
    h2 {
      margin-top: $v-spacer;
      margin-bottom: $v-spacer-md;
    }
  }
  //Style des accordeons sur les pages RGPD
  .tab {
    position: relative;
    margin-bottom: 1px;
    width: 100%;
    overflow: hidden;
    padding-bottom: 15px;
  }
  .tab h5 {
    padding-left: 20px;
  }
  .tab input {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  .tab label {
    position: relative;
    display: block;
    padding: 0 0 0 1em;
    background: $primary-color;
    color: #fff;
    font-weight: bold;
    line-height: 3;
    cursor: pointer;
  }
  .tab-content {
    max-height: 0;
    overflow: hidden;
    background: #f1f1f1;
    -webkit-transition: max-height .35s;
    -o-transition: max-height .35s;
    transition: max-height .35s;
  }
  .tab-content p {
    margin: 1em;
  }
  /* :checked */
  .tab input:checked ~ .tab-content {
    max-height: 2000px;
  }
  /* Icon */
  .tab label::after {
    position: absolute;
    right: 0;
    top: 0;
    display: block;
    width: 3em;
    height: 3em;
    line-height: 3;
    text-align: center;
    -webkit-transition: all .35s;
    -o-transition: all .35s;
    transition: all .35s;
  }
  .tab input[type=checkbox] + label::after {
    content: "+";
  }
  .tab input[type=radio] + label::after {
    content: "\25BC";
  }
  .tab input[type=checkbox]:checked + label::after {
    transform: rotate(315deg);
  }
  .tab input[type=radio]:checked + label::after {
    transform: rotateX(180deg);
  }
}
</style>
